import { render, staticRenderFns } from "./LocationSettingsHeader.vue?vue&type=template&id=3d60d10e&scoped=true"
import script from "./LocationSettingsHeader.vue?vue&type=script&lang=js"
export * from "./LocationSettingsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d60d10e",
  null
  
)

export default component.exports